import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface RootState {
  loading: boolean;
  loaderCount: number;
}

function createInitialState(): RootState {
  return {
    loading: false,
    loaderCount: 0,
  };
}

@Injectable()
@StoreConfig({ name: 'root' })
export class RootStore extends Store<RootState> {
  constructor() {
    super(createInitialState());
  }
}
